import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../utils/cn.js';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, className, ...rest },
  ref,
) {
  return (
    <label className={cn('switch', className)}>
      <input ref={ref} type="checkbox" role="switch" {...rest} />
      <span className="switch-track" aria-hidden />
      {label ? <span className="switch-label">{label}</span> : null}
    </label>
  );
});
